import { c as _c } from "react/compiler-runtime";
/**
 * Platform-specific navigation helpers
 * Web: Next.js navigation
 */
import { usePathname } from 'next/navigation';

/**
 * Returns the current route name/path
 * Web: returns pathname (e.g., '/profile', '/space')
 * Mobile: returns route name (e.g., 'Profile', 'Space')
 */
export const useRouteName = () => {
  const pathname = usePathname();
  return pathname || "/";
};

/**
 * Checks if the current route matches a given name
 * Handles platform differences in route naming
 */
export const useIsRoute = routeName => {
  const $ = _c(4);
  const pathname = usePathname();
  if (!pathname) {
    return false;
  }
  let t0;
  if ($[0] !== pathname) {
    t0 = pathname.toLowerCase().replace("/", "");
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const normalizedPath = t0;
  let t1;
  if ($[2] !== routeName) {
    t1 = routeName.toLowerCase();
    $[2] = routeName;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const normalizedRoute = t1;
  return normalizedPath === normalizedRoute || pathname === `/${routeName}`;
};